export const promocodesFailNames = Object.freeze({
  INVALID: 'Промокод недействителен',
  NOT_EXIST: 'Промокод не существует',
})
